import React from "react";
import styles from "../styles/QuickViewCard.module.css";
import Button from "./Button";

export default function QuickViewCard({ content }) {
  const {
    icon,
    title,
    description,
    features = [],
    image,
    href,
    accent = "var(--p-500)",
  } = content;

  return (
    <article className="card" style={{ "--accent": accent }}>
      <header className="cardHeader">
        <img className="cardIcon" src={icon} alt="" aria-hidden="true" />
        <div className="cardHeaderText">
          <h3 className="cardTitle">{title}</h3>
          <p className="cardDescription">{description}</p>
        </div>
      </header>
      <div className={styles.divider} />
      <ul className="bulletList">
        {features.map((feature, idx) => (
          <li key={`${title}-feature-${idx}`} className={styles.featureItem}>
            {feature}
          </li>
        ))}
      </ul>
      <div className={styles.imageWrap}>
        <img className={styles.image} src={image} alt={`${title} preview`} />
      </div>
      <footer className={styles.footer}>
        <Button size="btnMedium" href={href}>
          Learn More
        </Button>
      </footer>
    </article>
  );
}
